import { inject, Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { HttpService } from './http.service';
import { tap } from 'rxjs/operators';
import { ProductCategory } from '@shared/models';

@Injectable()
export class CategoryService implements OnDestroy {
    private httpService = inject(HttpService);
    readonly category$ = new BehaviorSubject<ProductCategory | null>(null);

    private subscriptions = new Subscription();

    /**
     * Dispatch
     */
    dispatch(slug: string): void {
        this.subscriptions.add(
            this.httpService
                .getCategory(slug)
                .pipe(
                    // delay(0),
                    tap((category) => this.category$.next(category)),
                )
                .subscribe(),
        );
    }

    /**
     * Destroy all pending subscritpions
     */
    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
